export default __webpack_public_path__ + "static/media/business-288b.347c72e7.jpg";